import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type FormContainerProps = {
	children?: React.ReactNode;
	className?: string;
	style?: any;
};

export const FormContainer = ({
	children,
	className,
	style,
}: FormContainerProps) => {
	return (
		<div className={clsx(styles.formContainer, className)} style={style}>
			{children}
		</div>
	);
};
